import React, {Suspense, lazy} from 'react';
import {HOSPITAL_DOCTOR_TAGGING_REPORT} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const HospitalDoctorTagging = lazy(() =>
  import('../../../screens/HospitalDoctorTagging')
    .then(module => ({default: module.HospitalDoctorTaggingReport})),
);

const HospitalDoctorTaggingNavigation = [
  {
    path: HOSPITAL_DOCTOR_TAGGING_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <HospitalDoctorTagging />
      </Suspense>
    ),
  },
];

export default HospitalDoctorTaggingNavigation;
